import React from "react";

const BasicInfo = ({ formData, setFormData }) => {
  return (
    <div className="hotel-register-section hmfsb">
        <div className="clp-header">
            <h4 className='ws-title'>Basic Information</h4>
        </div>

        <div className="hotel-form-box">
            <div className="hfbfsp">
                <div className="row hlibs">
                    <label for="propertyName" className="col-sm-6 hrltb">
                        <p>Name of the Property</p>
                        <p className="label-hint">Enter the name as on the property documents</p>
                    </label>
                    <div className="col-sm-6">
                        <input type="text" class="form-control hrifb" id="propertyName" />
                    </div>
                </div>
                <div className="row hlibs">
                    <label for="hotelRating" className="col-sm-6 hrltb">
                        <p>Hotel Star Rating</p>
                    </label>
                    <div className="col-sm-6">
                        <select class="form-select hrifb">
                            <option selected>select rating</option>
                            <option value="5">5</option>
                            <option value="4">4</option>
                            <option value="3">3</option>
                            <option value="2">2</option>
                            <option value="1">1</option>
                        </select>
                    </div>
                </div>
                <div className="row hlibs">
                    <label for="propertyBuilt" className="col-sm-6 hrltb">
                        <p>When was the property built?</p>
                    </label>
                    <div className="col-sm-6">
                        <select class="form-select hrifb">
                            <option selected>select a year</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                        </select>
                    </div>
                </div>
                <div className="row hlibs">
                    <label for="propertyBuilt" className="col-sm-6 hrltb">
                        <p>Accepting booking since?</p>
                        <p className="label-hint">Since when is this property available for guests to book</p>
                    </label>
                    <div className="col-sm-6">
                        <select class="form-select hrifb">
                            <option selected>select a year</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="hfb_line"></div>
            <div className="hfbfsp">
                <div className="hbf-title-box">
                    <p className="hbf-title">How can guests contact the property?</p>
                    <p className="label-hint">These contact details will be shared with the guests when they make a booking</p>
                </div>
                <div className="row hlibs">
                    <label for="email" className="col-sm-6 hrltb">
                        <p>Email ID</p>
                    </label>
                    <div className="col-sm-6">
                        <input type="text" class="form-control hrifb" id="email" />
                    </div>
                </div>
                <div className="row hlibs">
                    <label for="number" className="col-sm-6 hrltb">
                        <p>Mobile Number</p>
                    </label>
                    <div className="col-sm-6">
                        <input type="text" class="form-control hrifb" id="number" />
                    </div>
                </div>
                <div className="row hlibs">
                    <label for="landline" className="col-sm-6 hrltb">
                        <p>Landline Number (optional)</p>
                    </label>
                    <div className="col-sm-6">
                        <input type="text" class="form-control hrifb" id="landline" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default BasicInfo;
